import service from '@/api/index'

export const updatePassword = (data) => {
  return service({
    url: '/common/changePassword',
    method: 'post',
    data
  })
}

export function logout() {
  return service({
    url: '/system/logout', // 替换为真实接口地址
    method: 'post'
  })
}

export const userList = (data) => {
  return service({
    url: '/sysUserList',
    method: 'post',
    data
  })
}

export const departmentList = (query) => {
  return service({
    url: '/getDepartment',
    method: 'get',
    params: query
  })
}

export const positionList = (query) => {
  return service({
    url: '/getRole',
    method: 'get',
    params: query
  })
}

export function getRouters() {
  return request({
    url: '/system/menu/getRouters',
    method: 'get'
  })
}

export const exportSysUserList = (query, config) => {
  return service({
    url: '/exportSysUserList',
    method: 'get',
    params: query,
    ...config
  })
}

export const allMenu = (data) => {
  return service({
    url: '/allMenu',
    method: 'post',
    data
  })
}

export const createAccount = (data) => {
  return service({
    url: '/createAccount',
    method: 'post',
    data
  })
}

export const updateSysUser = (data) => {
  return service({
    url: '/updateSysUser',
    method: 'post',
    data
  })
}

export const sysLogList = (data) => {
  return service({
    url: '/sys/sysLogList',
    method: 'post',
    data
  })
}

export const exportSysLogList = (query, config) => {
  return service({
    url: '/sys/exportPersonalBillListByClub',
    method: 'get',
    params: query,
    ...config
  })
}




